import type { TSupportedMessageTypes } from './types';

export const messageSizeConfig: Record<TSupportedMessageTypes, number> = {
	text: 100,
	gift: 182,
	image: 205,
	video: 205,
	pack: 600,
	audio: 62,
};
